import { BreadcrumbItem } from 'components/breadcrumb/breadcrumbModel';
import { FormattedMessage, useIntl } from 'react-intl';

export interface DetailPageBreadcrumbProps {
  breadcrumbItem: BreadcrumbItem;
}

export function PriceAnalysisPageBreadcrumb({ breadcrumbItem }: DetailPageBreadcrumbProps) {
  const intl = useIntl();

  const filters = breadcrumbItem.filters ?? [];

  const styleFilter = filters.find(f => f.attribute === 'styleId');

  if (styleFilter && styleFilter.values.length > 0) {
    const rawValue = styleFilter.values[0];
    const label = typeof rawValue === 'string' ? rawValue : String(rawValue);
    return <span>{label}</span>;
  }

  const dateRangeFilter = filters.find(f => f.attribute === 'dateRange');
  let dateLabel = '';

  if (dateRangeFilter && dateRangeFilter.values.length > 0) {
    const dateValue = dateRangeFilter.values[0];
    const dateString =
      typeof dateValue === 'object' && dateValue !== null && 'from' in dateValue
        ? (dateValue as unknown as { from: string }).from
        : String(dateValue);

    if (dateString) {
      dateLabel = intl.formatDate(new Date(dateString), { dateStyle: 'short' });
    }
  }

  return (
    <div>
      <FormattedMessage id={'trading.price_analysis.title'} defaultMessage={'Price Analysis'} />
      {dateLabel && <span>&nbsp;- {dateLabel}</span>}
    </div>
  );
}
